module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SC-aaf6ff01090ce8e1fbaee32776e174b3.png";